import {
  THEME_BLACK_GOLD,
  THEME_TOP_WEDDING,
  THEME_WHITE_BLUE,
  THEME_WHITE_GOLD,
  THEME_WHITE_GREEN,
  THEME_WHITE_PINK,
  THEME_WHITE_RED
} from '@constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { getMerchantInfo } from '@util'
import React from 'react'
import { PROPERTY_HOTEL } from '@merchant-backend/constant'

// 店铺信息审核状态
export const SHOP_INFO_STATUS_TODO = '0'
export const SHOP_INFO_STATUS_REJECTED = '1'
export const SHOP_INFO_STATUS_PASSED = '2'

export const SHOP_INFO_STATUS_MAP = {
  [SHOP_INFO_STATUS_TODO]: 'verifying',
  [SHOP_INFO_STATUS_REJECTED]: 'rejected',
  [SHOP_INFO_STATUS_PASSED]: 'success'
}

/**
 * 装修主题色
 */
export const getThemeList = () => {
  const isSiDa = isSiDaProperty()
  const propertyId = getMerchantInfo().property_id
  return [
    {
      text: '默认',
      value: THEME_WHITE_RED
    },
    !!+getMerchantInfo().top_wedding
      ? {
          text: '典雅黑',
          value: THEME_TOP_WEDDING
        }
      : null,
    {
      text: '典雅白',
      value: THEME_WHITE_GOLD
    },
    {
      text: '尊贵黑',
      value: THEME_BLACK_GOLD
    },
    !isSiDa && propertyId !== PROPERTY_HOTEL
      ? {
          text: '清新绿',
          value: THEME_WHITE_GREEN
        }
      : null,
    !isSiDa && propertyId !== PROPERTY_HOTEL
      ? {
          text: '雅典蓝',
          value: THEME_WHITE_BLUE
        }
      : null,
    !isSiDa && propertyId !== PROPERTY_HOTEL
      ? {
          text: '樱花粉',
          value: THEME_WHITE_PINK
        }
      : null
  ].filter(Boolean)
}

export const VIDEO_TEXT =
  '可设置多个视频，其中第一个视频将在商家首页展示，视频大小不能超过1024M，时长建议控制在2分钟'

export const ENV_PHOTO_TEXT = (
  <p>
    店铺照片必须为门店照片，如店铺环境、店铺陈列、店铺工作人员展示等。
    <span style={{ color: '#448afc' }}>
      图片640像素≤宽度≤1024像素，高度≤2048像素，单张照片不超过10M。
    </span>
  </p>
)
